import { Box, Typography } from "@mui/material"
import { useAuth0 } from "ct-auth"
import { userOrg } from "../../../data-utils/authUtils"
import { useQueries } from "../../../data-utils/reactQueryHelpers"
import { resolveIdentityLabels } from "../../../data-utils/partnerBranding"

/**
 * CT-1163: inconspicuous partner-identity labels at the bottom of the left side panel.
 *
 * Renders "Managed by <Partner>" and/or "Powered by ChaosTrack" per the resolved
 * smart-default + per-org override logic (resolveIdentityLabels). Deliberately quiet:
 * tiny, muted type; hidden entirely when the side panel is collapsed (no room) and
 * when there is nothing to say. Self-contained — reads the current user's org from
 * the same HOME_USER_ORG query the header/theme use (served from cache).
 */
const PartnerIdentityLabels = ({ expanded }) => {
  const { user } = useAuth0()
  const { data: orgData } = useQueries.HOME_USER_ORG({ orgId: userOrg(user) })
  const { showManagedBy, partnerName } = resolveIdentityLabels(orgData)

  // Collapsed rail has no room for text; nothing to show → render nothing.
  // "Powered by ChaosTrack" is intentionally not rendered here — only the
  // partner "Managed by <Partner>" branding remains.
  if (!expanded || !showManagedBy) return null

  return (
    <Box
      sx={{
        // No divider here — it sits directly under the account block (which already
        // has a top hairline). A second divider read as stacked clutter. Tight, quiet
        // padding so the rail foot looks like one intentional block.
        px: 1.75,
        pt: 0.5,
        pb: 1.25,
      }}
    >
      {showManagedBy && (
        <Typography variant="caption" component="div" sx={{ color: "text.secondary", fontSize: 10.5, lineHeight: 1.4, opacity: 0.8 }}>
          Managed by {partnerName}
        </Typography>
      )}
    </Box>
  )
}

export default PartnerIdentityLabels
